import React, { useState, useContext, useEffect } from 'react'
import { icons } from '../../../utils/utilities';
import StoreCtx from '../../../context/store-context';
import styles from './global-navigation.module.scss';
import { IMenuItem } from '../../../models';
import { NavbarToggler, Navbar, Col, Collapse, Nav, NavItem, NavLink } from 'reactstrap';
import { INavigation } from '@interfaces/ux/navigation.interface';
import { NavigationPresenter } from '@presenters/ux/navigation.presenter';

const { MdMoreHoriz } = icons;
const { StoreContext } = StoreCtx; 

const GlobalNavigation = () => {
    const [menuIsOpen, setMenuIsOpen] = useState(true);
    const [items, setItems] = useState([]);
    
    const view: INavigation = {
        state: { 
            menuIsOpen: menuIsOpen,
            setMenuIsOpen: setMenuIsOpen,
            items: items,
            setItems: setItems
        },
        store: useContext(StoreContext)
    }
    const presenter = new NavigationPresenter(view);
    useEffect(() => {
        presenter.getTopMenuItems();
    },[]);

    return (
        <div className={styles.GlobalNavigation}>
            <Navbar dark expand="lg" className="navbar m-0 p-0">
                <NavbarToggler onClick={() => presenter.toogleNavigation()}>
                    <MdMoreHoriz></MdMoreHoriz>
                </NavbarToggler>

                <Col
                    className={styles.Date + " dark mt-1 d-md-none"}
                    xs={4} lg={2}>
                    {presenter.currentDate}
                 
                </Col>
                
                <Col xs={12} md={9} style={{padding:0}}>
                        <Collapse isOpen={presenter.menuIsOpen} navbar>
                            <Nav navbar>
                                {items.map((x: IMenuItem) => {
                                    let canSee = (x?.OCTAVIAUrl?.includes('admin')) ? presenter.getTotalPermissions() : true
                                    if(canSee){
                                        return (
                                            <NavItem className={styles.Link} key={`global-item-${x.Id}`}>
                                            <NavLink
                                                className={presenter.isActive(x) ? styles.NavLinkActive : styles.NavLink}
                                                active={presenter.isActive(x)}
                                                key={`global-link-${x.Id}`}
                                                onClick={() => presenter.redirectTo(x.OCTAVIAUrl)}>
                                                {x.OCTAVIAValorTraduccion}
                                            </NavLink>
                                        </NavItem>
                                        )
                                    }
                                })}
                            </Nav>
                        </Collapse> 
                </Col> 

                <Col md={3}
                    className={styles.Date + " dark mt-1 d-none d-md-inline-block"}
                >
                    {presenter.currentDate}
                </Col>

            </Navbar>
        </div>
    )
}
export default GlobalNavigation;

